<template>
  <ul>
    <menu-options-item close label="Abrir" @click="$emit('abrir')" />
    <menu-options-item close label="Excluir" @click="$emit('excluir')" />
  </ul>
</template>

<script>
import MenuOptionsItem from '../../../layout/context-menu/context-window-options-item'
export default {
  name: 'site-list-menu',
  props: ['site'],
  components: {MenuOptionsItem}
}
</script>
